import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  width: 100%;
  padding: 1rem;
  background-color: #f5f5f5;
  text-align: center;
  font-size: 0.875rem;
  color: #666;
  margin-top: auto;
  border-top: 1px solid #eee;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

const PoweredBy = styled.span`
  a {
    color: #0066cc;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Version = styled.span`
  &::before {
    content: '|';
    margin: 0 0.5rem;
    color: #ccc;
  }
`;

const Footer = () => {
  const { t } = useTranslation();
  const version = import.meta.env.VITE_APP_VERSION || '1.0.0';

  return (
    <FooterContainer>
      <FooterContent>
        <PoweredBy>
          {t('footer.poweredBy')} <a href="https://github.com/xmagic" target="_blank" rel="noopener noreferrer">Xmagic</a>
        </PoweredBy>
        <Version>
          {t('footer.version')} {version}
        </Version>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 